module.exports = __webpack_public_path__ + "static/media/haori-iori.06c2b2b3.png";